import { ConfigProvider, theme } from 'antd';

/**
 * antd tema yapılandırması — TEK kaynak (HisApp, PatientApp ve statik API'ler).
 *
 * v4'teki antd.compact.css'in v5 karşılığı: yoğunluk artık CSS değil tema algoritması.
 * Renkler marka token'larından (core/styles/brand.css) gelir — antd'nin fabrika mavisi
 * (#1890ff) yerine slate birincil + amber uyarı.
 */
export const antdTheme = {
    algorithm: theme.compactAlgorithm,
    token: {
        colorPrimary: '#34495E',
        colorLink: '#34495E',
        colorLinkHover: '#44607C',
        colorWarning: '#E0982A',
        // SEÇİLİ item zemini (dropdown/select option, date picker, cascader, menü) — antd
        // bunu colorPrimary'den türetirdi ve slate ile grimsi-mavi bir ton çıkıyordu.
        // Seçim de marka amber'i: grid'deki seçili satırla (Table.rowSelectedBg) aynı zemin.
        controlItemBgActive: '#F5DEB9',        // = --accent-row
        controlItemBgActiveHover: '#EFD3A8',
        colorBgLayout: '#F6F7F9',   // .ant-layout kendi zeminini basar; marka nötrüne bağla
        colorText: '#2C3E50',
        borderRadius: 6,
        fontFamily: "Manrope, 'Segoe UI', system-ui, -apple-system, sans-serif",
    },
    components: {
        // antd seçili satır zeminini colorPrimary'den türetiyor; slate primary ile grimsi
        // bir ton çıkıyor. Seçim marka amber'i olmalı.
        Table: {
            rowSelectedBg: '#F5DEB9',
            rowSelectedHoverBg: '#EFD3A8',
        },
        // Switch açık (true) durumu colorPrimary'den türüyor — slate'te kapalı/açık ayrımı
        // zayıf kalıyor. Açık durum marka amber'i olmalı.
        Switch: {
            colorPrimary: '#E0982A',
            colorPrimaryHover: '#C8801A',
        },
        // addonBefore label'larının zemini (İsim, Soyisim, Telefon, Boy, Kilo): antd bunu
        // colorFillAlter'dan (%2 siyah) türetiyor — renkli kart zeminlerinde (hasta kartının
        // cinsiyet kutusu) neredeyse şeffaf kalıp label'ı yutuyordu. Marka ikincil yüzeyine
        // sabitlendi; AddonBefore'un external varyantıyla aynı ton.
        Input: {
            addonBg: '#F0F2F5',   // = --surface-2
        },
        InputNumber: {
            addonBg: '#F0F2F5',
        },
    },
};

/**
 * Statik çağrılar — Modal.confirm/Modal.error, message.*, notification.* — React ağacının
 * DIŞINDA, kendi köklerinde render edilir. Bu yüzden ConfigProvider'ı göremezler ve antd'nin
 * fabrika temasına düşerler (v5'in bilinen davranışı: "static function can not consume context").
 * Onay modallarındaki birincil butonun mavi çıkmasının sebebi buydu — tema değil, kök farkı.
 *
 * holderRender o kökleri de aynı temaya sarar; 35+ çağrı yerini App.useApp()'e taşımak gerekmez.
 * Uygulama açılışında bir kez çağrılır (index.js).
 */
export function applyAntdThemeToStaticApis() {
    ConfigProvider.config({
        holderRender: (children) => (
            <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>
        ),
    });
}
